import type { EntityStatus, Group } from '../types';

export enum MyGroupsFilter {
  All,
  AdminOnly,
}

export interface FilteredMyGroups {
  readonly cursor: string | null;
  readonly hasNextPage: boolean;
  readonly groupIds: Group['id'][];
  readonly favoriteGroupIds: Group['id'][];
  readonly status: EntityStatus;
}

export type MyGroups = Partial<Record<MyGroupsFilter, FilteredMyGroups>>;
